import LinearProgress from '@mui/material/LinearProgress';
import { keyframes } from '@mui/material/styles';
import { useIsFetching } from '@tanstack/react-query';
import { useNavigation } from 'react-router';

// Fade in only after a short delay, so quick requests don't flash the bar.
const appear = keyframes`from { opacity: 0; } to { opacity: 1; }`;

/**
 * Thin bar under the header while a page is being opened or data is being
 * (re)fetched, so cached content on screen is never mistaken for fresh data.
 */
export function NavigationProgress() {
  const navigating = useNavigation().state !== 'idle';
  const fetching = useIsFetching() > 0;
  if (!navigating && !fetching) return null;
  return (
    <LinearProgress
      aria-label="Loading"
      sx={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: 2,
        opacity: 0,
        animation: `${appear} 150ms ease-in 150ms forwards`,
      }}
    />
  );
}
